import clsx from "clsx";
import styled from "styled-components";
import React, { useState, useContext } from "react";
import translationIdle from "./images/Btn/Translate/translationIdle.png";
import translationHover from "./images/Btn/Translate/translationHover.png";
import translationActive from "./images/Btn/Translate/translationActive.png";
import translationActiveHover from "./images/Btn/Translate/translationActiveHover.png";
import { requestTranslation } from "@futures-platform/i18n";
import { DataContext } from "../store/GlobalState";
const TranslationBtn = ({
  // color = '#b0b0b0',
  width = "39px",
  height = "39px",
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = /Mobi/.test(window.navigator.userAgent)
  const { state: { contentData } } = useContext(DataContext);
  return (
    <FlagWrapper
      data-title={contentData?.title}
      data-action-id="voting"
      data-vote-type={"up"}
      data-vote-status={isNewsBookMarked ? "voted" : "not-voted"}
      onMouseOver={() => {
        setIsHover(() => true);
      }}
      onMouseOut={() => {
        setIsHover(() => false);
      }}
      className="vote-up voted-btn"
      id="vote-up"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: "pointer",
      }}
    >
      {!isAuthed ? (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby={requestTranslation("UpvoteSVG")}
          aria-describedby={requestTranslation("UpvoteSVG")}
        >
          <title>{requestTranslation("UpvoteSVG")}</title>
          <mask
            id="mask0_4014_2171"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="36"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4014_2171)">
            <rect width="36" height="36" fill="#E8EBEB" />
            <circle cx="18" cy="18" r="17" fill="white" />
          </g>
          <path
            d="M25.5 17.5C25.5 15.5969 24.9999 15.197 23.4999 15.1969H19.4999L19.9999 10.6969C20.1665 9.19693 18.4999 9.19695 17.9999 10.1969L15 15.5969V23.7969C15 23.7969 16.4999 24.197 18.4999 24.197C20.4999 24.197 22 24.197 23.5 23.5C25 22.803 25.5 19.5 25.5 17.5Z"
            fill="#637282"
          />
          <path
            d="M11.5 23.6969L14 23.7969V15.5969L11.5 15.6969C10.5002 15.7369 10.5 15.6969 10.5 16.6969V22.6969C10.5 23.6969 10.5008 23.657 11.5 23.6969Z"
            fill="#637282"
          />
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("UpvoteSVG")}
                  aria-describedby={requestTranslation("UpvoteSVG")}
                >
                  <title>{requestTranslation("UpvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2191"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2191)">
                    <rect width="36" height="36" fill="#00C3FF" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M25.5 17.5C25.5 15.5969 24.9999 15.197 23.4999 15.1969H19.4999L19.9999 10.6969C20.1665 9.19693 18.4999 9.19695 17.9999 10.1969L15 15.5969V23.7969C15 23.7969 16.4999 24.197 18.4999 24.197C20.4999 24.197 22 24.197 23.5 23.5C25 22.803 25.5 19.5 25.5 17.5Z"
                    fill="#00C3FF"
                  />
                  <path
                    d="M11.5 23.6969L14 23.7969V15.5969L11.5 15.6969C10.5002 15.7369 10.5 15.6969 10.5 16.6969V22.6969C10.5 23.6969 10.5008 23.657 11.5 23.6969Z"
                    fill="#00C3FF"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("UpvoteSVG")}
                  aria-describedby={requestTranslation("UpvoteSVG")}
                >
                  <title>{requestTranslation("UpvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2181"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2181)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M25.5 17.5C25.5 15.5969 24.9999 15.197 23.4999 15.1969H19.4999L19.9999 10.6969C20.1665 9.19693 18.4999 9.19695 17.9999 10.1969L15 15.5969V23.7969C15 23.7969 16.4999 24.197 18.4999 24.197C20.4999 24.197 22 24.197 23.5 23.5C25 22.803 25.5 19.5 25.5 17.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M11.5 23.6969L14 23.7969V15.5969L11.5 15.6969C10.5002 15.7369 10.5 15.6969 10.5 16.6969V22.6969C10.5 23.6969 10.5008 23.657 11.5 23.6969Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("UpvoteSVG")}
                  aria-describedby={requestTranslation("UpvoteSVG")}
                >
                  <title>{requestTranslation("UpvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2171"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2171)">
                    <rect width="36" height="36" fill="#E8EBEB" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M25.5 17.5C25.5 15.5969 24.9999 15.197 23.4999 15.1969H19.4999L19.9999 10.6969C20.1665 9.19693 18.4999 9.19695 17.9999 10.1969L15 15.5969V23.7969C15 23.7969 16.4999 24.197 18.4999 24.197C20.4999 24.197 22 24.197 23.5 23.5C25 22.803 25.5 19.5 25.5 17.5Z"
                    fill="#637282"
                  />
                  <path
                    d="M11.5 23.6969L14 23.7969V15.5969L11.5 15.6969C10.5002 15.7369 10.5 15.6969 10.5 16.6969V22.6969C10.5 23.6969 10.5008 23.657 11.5 23.6969Z"
                    fill="#637282"
                  />
                </svg>
              ) : (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-labelledby={requestTranslation("UpvoteSVG")}
                  aria-describedby={requestTranslation("UpvoteSVG")}
                >
                  <title>{requestTranslation("UpvoteSVG")}</title>
                  <mask
                    id="mask0_4014_2181"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="36"
                    height="36"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 18C36 27.9419 27.941 36 18.0006 36C8.05905 36 0 27.9419 0 18C0 8.05815 8.05905 0 18.0006 0C27.941 0 36 8.05815 36 18Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4014_2181)">
                    <rect width="36" height="36" fill="#689AB9" />
                    <circle cx="18" cy="18" r="17" fill="white" />
                  </g>
                  <path
                    d="M25.5 17.5C25.5 15.5969 24.9999 15.197 23.4999 15.1969H19.4999L19.9999 10.6969C20.1665 9.19693 18.4999 9.19695 17.9999 10.1969L15 15.5969V23.7969C15 23.7969 16.4999 24.197 18.4999 24.197C20.4999 24.197 22 24.197 23.5 23.5C25 22.803 25.5 19.5 25.5 17.5Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M11.5 23.6969L14 23.7969V15.5969L11.5 15.6969C10.5002 15.7369 10.5 15.6969 10.5 16.6969V22.6969C10.5 23.6969 10.5008 23.657 11.5 23.6969Z"
                    fill="#689AB9"
                  />
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  );
};

export default TranslationBtn;

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`;

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`;
